<template>
  <div style="background-color: #2f2c2c; padding-bottom: 100px">
    <div class="row">
      <div class="col-md-12" style="text-align: center">
        <img
          style="max-width: 600px; margin: auto"
          class="img-responsive lazy"
          src="https://webimages.trailfinders.com/image/upload/w_600/v1629103143/tf50/tf50banner.jpg"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <p
          class="text-lg text-center"
          style="font-size: 22px; padding-top: 30px"
        >
          We’re delighted you can join us and we look forward to celebrating
          with you.
        </p>
        <p
          class="text-lg text-center"
          style="font-size: 22px; padding-bottom: 30px"
        >
          Please advise if you have any dietary requirements or allergies.
        </p>
      </div>
    </div>

    <div class="row mb-3 pb-3" v-show="!dataSuccess">
      <div class="col-md-3">&nbsp;</div>
      <div class="col-md-6">
        <b-form-textarea
          class="form-control"
          id="textarea"
          v-model="details"
          placeholder="Dietary requirements or allergies"
          rows="6"
          max-rows="6"
        ></b-form-textarea>
      </div>
    </div>
    <div class="row pt-3" v-show="!dataSuccess">
      <div class="col-md-3">&nbsp;</div>
      <div class="col-md-6" style="text-align: center; padding-top: 20px">
        <button
          class="btn btn-success m-b-xl text-center"
          @click="saveDetails"
          :disabled="details === ''"
        >
          Send Details
        </button>
      </div>
    </div>

    <div class="row m-y-l pt-3" v-if="dataSuccess">
      <div class="col-md-3">&nbsp;</div>
      <div class="col-md-6 align-center">
        <b-alert variant="success" :show="dataSuccess">
          <p style="text-align: center">
            You have successfully sent your details.
          </p></b-alert
        >
      </div>
    </div>

    <div class="row" style="padding-bottom: 100px">
      <div class="col-md-2"></div>
      <div class="col-md-8" style="text-align: center; padding: 20px">
        <h3>Accomodation and Travel Information</h3>
        <p>
          We have secured a special rate at the DoubleTree by Hilton Chelsea
          with free cancellation 72 hours prior to arrival.<br /><br />A Single
          room is £109, a Double or Twin room is £119 and a Triple room is £159
          (breakfast included).<br /><br />To receive these rates please call
          the hotel on <a href="tel:020 7411 2200">020 7411 2200</a> and quote
          <strong>ATF50</strong> or click
          <a
            href="https://www.hilton.com/en/book/reservation/deeplink/?ctyhocn=LONLCDI&groupCode=ATF50&arrivaldate=2021-10-08&departuredate=2021-10-09&cid=OM,WW,HILTONLINK,EN,DirectLink&fromId=HILTONLINKDIRECT"
            >here</a
          >
          before Thursday 9th September.
        </p>
        <p>
          Alternatively, the Premier Inn Putney Bridge is only a 10-minute walk
          away.
        </p>
        <p>Please note there is no car parking available at the venue.</p>
        <p>
          The closest tube station is Putney Bridge (0.3 miles) and closest
          train station is Putney (1.1 miles).
        </p>
      </div>
      <div class="col-md-2"></div>
    </div>
  </div>
</template>

<script>
import { saveTF50Details } from "@/services/api.js";
export default {
  data() {
    return {
      details: "",
      id: "",
      dataSuccess: false,
      dataError: false,
    };
  },
  async mounted() {
    //const urlParams = new URLSearchParams(window.location.search);
    this.id = this.$route.params.id;
  },
  methods: {
    async saveDetails() {
      this.dataSuccess = false;
      this.dataError = false;
      let res = await saveTF50Details({ id: this.id, details: this.details });
      if (res.status && res.status <= 399) {
        this.dataSuccess = true;
        console.log("done");
      } else {
        this.dataError = true;
        console.log("error");
      }
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/index";
.main-app-container {
  color: white;
  font-size: 18px;
}
.main-app-container a {
  color: #ffa409;
  text-decoration: underline;
}
#riq_requestcall {
  display: none !important;
}
</style>
